module.exports = __webpack_public_path__ + "img/mile4-m@2.d9d875a2.webp";